import {
  AutoComplete,
  Button,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Select,
  message,
} from "antd";
import {FormInstance} from "antd/lib/form/Form";
import React, {useContext, useEffect, useMemo, useRef, useState} from "react";
import type {InputRef} from "antd";
import {FIELD_TYPE, FORMAT_TIME, LOAI_PHIEU_KHO} from "types/enums";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {pharmacyStoreService, catalogService, storeService} from "api";

import moment from "moment";
import InputCode from "components/common/Code/Code";
import {formatDateToString} from "helper/common";
import {listTT_ThuocKho} from "data/list";
import Notification from "components/common/notification/notification";
type EditableRowProps = {
  index: number;
};
const {INPUT, BUTTON, NUMBER, DATE, AUTO_COMPLETE, COMBO_BOX, CURRENCY, CODE} =
  FIELD_TYPE;
export type EditableCellProps = {
  title: React.ReactNode;
  editable?: boolean;
  children: React.ReactNode;
  dataIndex: any;
  record: any;
  selected: boolean;
  options: any[];
  name: string;
  index: number;
  type: FIELD_TYPE;
  disabled?: boolean;
  value?: any;
  onChange?: (e) => void;
  handleSave: (record, index) => void;
  onFocus?: () => void;
  onPressEnter?: (e) => void;
  addonAfter?: any;
  rules?: any;
  hidden?: boolean;
  autoFocus?: boolean;
};

export const EditableContext = React.createContext<FormInstance<any> | null>(
  null
);

export const EditableRow: React.FC<EditableRowProps> = ({index, ...props}) => {
  const [form] = Form.useForm();
  form.setFieldValue("khoId", "");
  return (
    <Form form={form} component={false}>
      <EditableContext.Provider value={form}>
        <tr {...props} />
      </EditableContext.Provider>
    </Form>
  );
};

export const EditableCell: React.FC<EditableCellProps> = ({
  title,
  editable,
  children,
  dataIndex,
  record,
  selected,
  options,
  handleSave,
  name,
  index,
  type,
  onChange,
  onPressEnter,
  disabled,
  value,
  hidden,
  autoFocus,
  ...restProps
}) => {
  const form = useContext(EditableContext)!;
  const [inputValue, setInputValue] = useState({});
  const [newOptions, setNewOptions] = useState<any[]>(options);
  const [listSearchMedicine, setListSearchMedicine] = useState<any[]>();
  const dispatch = useAppDispatch();
  const [currentLo, setCurrentLo] = useState(record?.soLo || null);
  const [currentMedicine, setCurrentMedicine] = useState();
  const khoXuatId = useAppSelector(state => state.tableAdd.khoXuatId);
  const khoKiemKeId = useAppSelector(state => state.inventory.khoKiemKeId);
  const donViTinhList = useAppSelector(
    state => state.medicalSuppliesReducer.donViTinhList
  );
  const [max, setMax] = useState(null);
  const [rules, setRules] = useState([]);

  const handleSetFieldValue = (dataIndex, value) => {
    form.setFieldValue(dataIndex, value);
    setInputValue({...inputValue, [dataIndex]: value});
    handleSave(form.getFieldsValue(), index);
  };

  useEffect(() => {
    if (record) {
      setMaxOfCell();
      setRulesOfCell();
      setGiaTriHang();
      setListNguonThuoc();
      if (dataIndex == "soLo") {
        setCurrentLo(record["soLo"]);
      }
      if (dataIndex == "tinhTrang") {
      }
    }
  }, []);
  useEffect(() => {
    setListUnit();
  }, [donViTinhList]);
  useEffect(() => {
    if (dataIndex == "soLo" && currentLo && khoKiemKeId != null) {
      setValueByLo(currentLo, khoKiemKeId);
    }
  }, [currentLo]);
  useEffect(() => {
    if (currentMedicine) {
      setValueByMedicine(currentMedicine);
    }
  }, [currentMedicine]);

  const setListUnit = async () => {
    if (dataIndex == "donViTinhId") {
      try {
        const donViTinhId = form.getFieldValue("donViTinhId");
        const listUnit = donViTinhList;
        const unitFind = listUnit.find(item => item.id === donViTinhId);
        // setNewOptions(listUnit.map((e) => ({ value: e.id, label: e.name })));
        if (unitFind) {
          setNewOptions([
            {
              value: unitFind.id,
              label: unitFind.name,
            },
          ]);
        }
      } catch (error) {
        setNewOptions([]);
      }
    }
  };

  const setValueByMedicine = currentMedicine => {
    handleSetFieldValue("thuocId", currentMedicine?.id);
    handleSetFieldValue("tenThuoc", currentMedicine?.name);
    handleSetFieldValue("duocChinh", currentMedicine?.duocChinh);
    handleSetFieldValue("nhomThuoc", currentMedicine?.nhomThuoc);
    handleSetFieldValue("hoatChat", currentMedicine?.hoatChat);
    handleSetFieldValue("donViTinhId", currentMedicine?.donViTinhId);
    handleSetFieldValue("hoatChat", currentMedicine?.hoatChat);
    handleSetFieldValue("hamLuong", currentMedicine?.hamLuong);
    handleSetFieldValue("baoCheId", currentMedicine?.baoChe);
    handleSetFieldValue("ngayNhap", currentMedicine?.ngayNhap);
    handleSetFieldValue("baoQuan", currentMedicine?.baoQuan);
  };
  const setValueByLo = async (soLo, khoId) => {
    var detailLo = await getDetailLo(soLo, khoId);
    handleSetFieldValue(
      "thuocId",
      detailLo.thuocId != null ? detailLo.thuocId.toString() : null
    );
    handleSetFieldValue("tenThuoc", detailLo?.tenThuoc);
    handleSetFieldValue("hanSuDung", moment(detailLo?.ngayHetHan));
    handleSetFieldValue("tonKho", detailLo?.tonKho);
    handleSetFieldValue("donGiaNhap", detailLo?.donGiaNhap);
    handleSetFieldValue("ngayNhap", detailLo?.ngayNhap);
    handleSetFieldValue("baoCheId", detailLo?.baoCheId);
    handleSetFieldValue("duocChinhId", detailLo?.duocChinhId);
    handleSetFieldValue("baoQuan", detailLo?.baoQuan);
    handleSetFieldValue("vat", detailLo?.vat);
    handleSetFieldValue("hoatChat", detailLo?.hoatChat);
    handleSetFieldValue("nhomThuoc", detailLo?.nhomThuoc);
    handleSetFieldValue("nuocSanXuat", detailLo?.nuocSanXuat);
    handleSetFieldValue("nhaCungCap", detailLo?.nhaCungCap);
    handleSetFieldValue("donViTinhId", detailLo?.donViTinhId);
    handleSetFieldValue(
      "ngaySanXuat",
      detailLo?.ngaySanXuat ? moment(detailLo?.ngaySanXuat) : null
    );
    handleSetFieldValue(
      "ngayHetHan",
      detailLo?.ngayHetHan ? moment(detailLo.ngayHetHan) : null
    );
    handleSetFieldValue(
      "ngayNhap",
      detailLo?.ngayNhap ? moment(detailLo?.ngayNhap) : null
    );

    // await getListUnitByMedicineId(detailLo?.thuocId);
  };

  const setMaxOfCell = () => {
    // if (dataIndex == "vat") {
    //   setMax(100);
    // }
    // if (dataIndex == "soLuongNhap" && typePhieu == LOAI_PHIEU_KHO.XUAT) {
    //   setMax(record["tonKho"]);
    // }
  };
  const setRulesOfCell = () => {
    // if (dataIndex == "thuocId") {
    //   setRules([{required: true, message: "Chưa có mã thuốc"}]);
    // }
  };
  const getDetailLo = async (soLo, khoId) => {
    try {
      const res = await pharmacyStoreService.getDetailLo(soLo, khoId);

      return res;
    } catch (error) {
      Notification("error", "Đã có lỗi khi lấy thông tin của số lô vừa nhập");
      return null;
    }
  };

  const getListLoInStoreByParams = async params => {
    if (khoKiemKeId == null) {
      return [];
    } else {
      try {
        const res = await storeService.getListLoInStoreByParams(params);

        return res;
      } catch (error) {
        // Notification("error",
        //   "Đã có lỗi khi lấy danh sách lô thuốc của loại thuốc vừa nhập"
        // );
        Notification(
          "info",
          "Không có lô thuốc nào thỏa mãn các tham số đã chọn"
        );
        return [];
      }
    }
  };

  const setSoLuongChenhLech = () => {
    const soLuongChenhLech =
      form.getFieldValue("soLuongTonPM") - form.getFieldValue("soLuongTonThuc");
    form.setFieldValue("soLuongChenhLech", soLuongChenhLech);
    setGiaTriHang();
  };
  const clearThuoc = () => {
    handleSetFieldValue("tenThuoc", null);
    handleSetFieldValue("hanSuDung", null);
    handleSetFieldValue("ngaySanXuat", null);
    handleSetFieldValue("baoCheId", null);
    handleSetFieldValue("duocChinh", null);
    handleSetFieldValue("thuocId", null);
    handleSetFieldValue("ngayHetHan", null);
    handleSetFieldValue("donGiaNhap", null);
    handleSetFieldValue("donGiaXuat", null);
    handleSetFieldValue("soLuongNhap", null);
    handleSetFieldValue("vat", null);
    handleSetFieldValue("hoatChat", null);
    handleSetFieldValue("nuocSanXuat", null);
    handleSetFieldValue("nhaCungCap", null);
    handleSetFieldValue("donViTinhId", null);
  };
  const setListMedicineByParams = async () => {
    let params: any = {
      tenThuoc: form.getFieldValue("tenThuoc"),
      donViTinhId: form.getFieldValue("donViTinhId"),
      baoCheId: form.getFieldValue("baoCheId"),
      duocChinhId: form.getFieldValue("duocChinhId"),
      // hoatChatId: form.getFieldValue('hoatChatId')
    };
    let listMedicine: any[] = [];

    if (khoKiemKeId == null) {
      Notification("warning", "Chọn kho xuất để lấy thông tin thuốc trong kho");
    } else {
      params = {...params, khoId: khoKiemKeId};
      const res = await storeService.getListMedicineInStoreByParams(params);
      listMedicine = res;
      setListSearchMedicine(res);
    }

    if (dataIndex == "thuocId") {
      setNewOptions(listMedicine.map(e => ({value: e.id, label: e.id})));
    }
    if (dataIndex == "tenThuoc") {
      setNewOptions(listMedicine.map(e => ({value: e.name, label: e.name})));
    }
  };
  const getDetailMedicineById = async id => {
    try {
      const res = await pharmacyStoreService.getPharmacy(id);
      return res;
    } catch (error) {
      return null;
    }
  };

  const getListNguonThuoc = async () => {
    try {
      const res = await storeService.getListNguonThuoc();
      return res;
    } catch (error) {
      return [];
    }
  };

  const setGiaTriHang = () => {
    const soLuongTonThuc = form.getFieldValue("soLuongTonThuc");
    const donGiaNhap = form.getFieldValue("donGiaNhap");
    const giaTriHang = soLuongTonThuc * donGiaNhap;
    handleSetFieldValue("giaTriHang", giaTriHang);
  };

  const setListNguonThuoc = async () => {
    if (dataIndex == "nguonThuocId") {
      const res = await getListNguonThuoc();
      setNewOptions(res.data.map(e => ({value: e.id, label: e.name})));
    }
  };
  const setSoLuongChenh = () => {
    const soLuongTonThuc = form.getFieldValue("soLuongTonThuc");
    const soLuongTon = form.getFieldValue("soLuongTon");
    const soLuongChenhLech = soLuongTonThuc - soLuongTon;
    handleSetFieldValue("soLuongChenhLech", soLuongChenhLech);
  };

  // useEffect(() => {
  //   inputRef.current?.focus();
  // }, [editing]);

  let childNode = children;

  if (type == INPUT) {
    childNode = (
      <Form.Item
        name={dataIndex}
        initialValue={record[dataIndex]}
        rules={rules}
      >
        <Input
          disabled={disabled}
          onChange={async e => {
            setInputValue({...inputValue, [dataIndex]: e.target.value});
            handleSave(form.getFieldsValue(), index);
            if (dataIndex == "thuocId") {
              alert(e.target.value);
            }
          }}
          autoFocus={false}
        ></Input>
      </Form.Item>
    );
  }
  if (type == DATE) {
    childNode = (
      <Form.Item
        name={dataIndex}
        initialValue={record[dataIndex] ? moment(record[dataIndex]) : null}
      >
        <DatePicker
          disabled={disabled}
          onChange={() => {
            handleSave(form.getFieldsValue(), index);
          }}
          format={FORMAT_TIME.dayFull}
        ></DatePicker>
      </Form.Item>
    );
  }
  if (type == NUMBER) {
    childNode = (
      <Form.Item
        name={dataIndex}
        initialValue={record[dataIndex]}
        rules={rules}
      >
        <InputNumber
          disabled={disabled}
          onChange={e => {
            setInputValue({...inputValue, [dataIndex]: e});
            handleSave(form.getFieldsValue(), index);

            if (dataIndex == "soLuongTonThuc") {
              setGiaTriHang();
              setSoLuongChenh();
            }
          }}
          onClick={e => {}}
          max={max}
          {...restProps}
        ></InputNumber>
      </Form.Item>
    );
  }
  if (type == AUTO_COMPLETE) {
    childNode = (
      <Form.Item
        name={dataIndex}
        initialValue={record[dataIndex]}
        rules={rules}
      >
        <AutoComplete
          autoFocus={autoFocus}
          showSearch
          allowClear
          notFoundContent={null}
          value={value}
          defaultActiveFirstOption={false}
          filterOption={(inputValue, option) =>
            option?.label
              .toString()
              .toUpperCase()
              .indexOf(inputValue.toUpperCase()) !== -1
          }
          options={newOptions}
          disabled={disabled}
          {...restProps}
          onClick={async e => {
            // if (dataIndex == "thuocId" || dataIndex == "tenThuoc") {
            //   setListMedicineByParams();
            // }
            if (dataIndex == "soLo") {
              const listLo = await getListLoInStoreByParams({
                tenThuoc: form.getFieldValue("tenThuoc"),
                khoId: khoXuatId,
                donViTinh: form.getFieldValue("donViTinhId"),
                ngaySanXuat: formatDateToString(
                  form.getFieldValue("ngaySanXuat"),
                  FORMAT_TIME.dayFull
                ),
                ngayHetHan: formatDateToString(
                  form.getFieldValue("ngayHetHan"),
                  FORMAT_TIME.dayFull
                ),
              });
              setNewOptions(listLo.map(e => ({value: e.soLo, label: e.soLo})));
            }
          }}
          onClear={() => {
            if (dataIndex == "tenThuoc" || dataIndex == "thuocId") {
              setCurrentMedicine(null);
            }
          }}
          onChange={async e => {
            setInputValue({...inputValue, [dataIndex]: e});
            handleSave(form.getFieldsValue(), index);

            if (dataIndex == "soLo") {
              setCurrentLo(e);
              handleSetFieldValue("tenThuoc", null);
              handleSetFieldValue("hanSuDung", null);
              handleSetFieldValue("ngaySanXuat", null);
              handleSetFieldValue("baoCheId", null);
              handleSetFieldValue("duocChinhId", null);
              handleSetFieldValue("thuocId", null);
              handleSetFieldValue("ngayHetHan", null);
              handleSetFieldValue("donGiaNhap", null);
              handleSetFieldValue("donGiaXuat", null);
              handleSetFieldValue("soLuongNhap", null);
              handleSetFieldValue("ngayHetHan", null);
              handleSetFieldValue("vat", null);
              handleSetFieldValue("hoatChat", null);
              handleSetFieldValue("nuocSanXuat", null);
              handleSetFieldValue("nhaCungCap", null);
              handleSetFieldValue("donViTinhId", null);
            }
            if (dataIndex == "thuocId") {
              const detailMedicine = await getDetailMedicineById(e);
              setCurrentMedicine(detailMedicine);
              handleSetFieldValue("soLo", null);
              handleSetFieldValue("tenThuoc", null);
              handleSetFieldValue("hanSuDung", null);
              handleSetFieldValue("ngaySanXuat", null);
              handleSetFieldValue("baoCheId", null);
              handleSetFieldValue("duocChinh", null);
              handleSetFieldValue("ngayHetHan", null);
              handleSetFieldValue("donGiaNhap", null);
              handleSetFieldValue("donGiaXuat", null);
              handleSetFieldValue("soLuongNhap", null);
              handleSetFieldValue("vat", null);
              handleSetFieldValue("hoatChat", null);
              handleSetFieldValue("nuocSanXuat", null);
              handleSetFieldValue("nhaCungCap", null);
              handleSetFieldValue("donViTinhId", null);
            }

            if (dataIndex == "tenThuoc") {
              const selectedThuocId = listSearchMedicine.find(
                medicine => medicine.name == e
              ).id;

              const detailMedicine = await getDetailMedicineById(
                selectedThuocId
              );
              setCurrentMedicine(detailMedicine);

              setListMedicineByParams();
              handleSetFieldValue("soLo", null);
              handleSetFieldValue("thuocId", null);
              handleSetFieldValue("hanSuDung", null);
              handleSetFieldValue("baoCheId", null);
              handleSetFieldValue("duocChinhId", null);
              handleSetFieldValue("ngaySanXuat", null);
              handleSetFieldValue("ngayHetHan", null);
              handleSetFieldValue("donGiaNhap", null);
              handleSetFieldValue("donGiaXuat", null);
              handleSetFieldValue("soLuongNhap", null);
              handleSetFieldValue("vat", null);
              handleSetFieldValue("hoatChat", null);
              handleSetFieldValue("nuocSanXuat", null);
              handleSetFieldValue("nhaCungCap", null);
              handleSetFieldValue("donViTinhId", null);
            }

            // lay list so lo
          }}
        ></AutoComplete>
      </Form.Item>
    );
  }
  if (type == COMBO_BOX) {
    childNode = (
      <Form.Item
        style={{margin: 0}}
        name={dataIndex}
        initialValue={record[dataIndex]}
      >
        <Select
          showSearch
          style={{
            width: "100%",
          }}
          filterOption={(input, option) =>
            (option?.label.toString().toLowerCase() ?? "").includes(
              input.toLowerCase()
            )
          }
          placeholder={"Chọn"}
          options={newOptions}
          disabled={disabled}
          allowClear={true}
          onChange={e => {
            setInputValue({...inputValue, [dataIndex]: e.value});
            handleSave(form.getFieldsValue(), index);
          }}
          onClick={async e => {
            if (dataIndex == "donViTinhId") {
              setListUnit();
              // const tenThuoc = form.getFieldValue("tenThuoc");
              // const thuocId = form.getFieldValue("thuocId");
              // let listUnit: any = null;

              // if (thuocId) {
              //   const res = await getListUnitByThuocId(thuocId);
              //   listUnit = res;
              // } else {
              //   const res = await getListUnit();
              //   listUnit = res.data;
              // }
              // setNewOptions(
              //   listUnit.map((e) => ({ value: e.id, label: e.name }))
              // );
            }
          }}
          {...restProps}
        />
      </Form.Item>
    );
  }

  if (type == CURRENCY) {
    childNode = (
      <Form.Item name={dataIndex} initialValue={record[dataIndex]}>
        <InputNumber
          disabled={disabled}
          defaultValue={value}
          formatter={value =>
            `${Math.round(value)?.toString()}`.replace(
              /\B(?=(\d{3})+(?!\d))/g,
              ","
            )
          }
          parser={value => value!.replace(/\$\s?|(,*)/g, "")}
          onChange={e => {
            setInputValue({...inputValue, [dataIndex]: e.value});
            handleSave(form.getFieldsValue(), index);
          }}
          placeholder={"Nhập"}
          addonAfter="VNĐ"
          stringMode
          controls={false}
          min={0}
          {...restProps}
        />
      </Form.Item>
    );
  }
  if (type == CODE) {
    childNode = (
      <Form.Item
        name={dataIndex}
        initialValue={record[dataIndex]?.toString().toUpperCase()}
      >
        <InputCode
          // {...props}
          value={value?.toString().toUpperCase()}
          placeholder={"Nhập"}
          onChange={e => {
            if (onChange) {
              onChange(e);
            }
            setInputValue({
              ...inputValue,
              [dataIndex]: e.target.value.toString().toUpperCase(),
            });
            handleSave(form.getFieldsValue(), index);
          }}
          onPressEnter={e => {
            if (dataIndex == "soLo") {
              handleSetFieldValue("thuocId", "a");
              handleSetFieldValue("hanSuDung", "a");
              handleSetFieldValue("donGia", "a");
            }
          }}
        ></InputCode>
      </Form.Item>
    );
  }
  if (type == BUTTON) {
    childNode = (
      <Button
        type="ghost"
        className="btn-sub"
        onClick={() => {
          handleSetFieldValue(
            "soLuongTonThuc",
            form.getFieldValue("soLuongTon")
          );
          setGiaTriHang();
          setSoLuongChenh();
        }}
      >
        Điền
      </Button>
    );
  }

  return <td {...restProps}>{childNode}</td>;
};
